import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { formatRut } from 'rutlib/lib';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { EntregaEquipoLinkService } from 'src/app/pages/services/entrega-equipo-link.service';
import { EntregaEquipoLink } from 'src/app/shared/models/entrega-equipo-link.interface';
import { EditarLinkDialogComponent } from '../editar-link-dialog/editar-link-dialog.component';

@Component({
  selector: 'app-listar-pendientes-entrega-equipos',
  templateUrl: './listar-pendientes-entrega-equipos.component.html',
  styleUrls: ['./listar-pendientes-entrega-equipos.component.css']
})
export class ListarPendientesEntregaEquiposComponent implements OnChanges {

  @Input() pendientes_List!: EntregaEquipoLink[];
  @Output() actualizado: EventEmitter<boolean> = new EventEmitter();

  displayedColumns: string[] = ['rut', 'nombreTrabajador', 'tipoMovimiento', 'estadoLink', 'fechaGeneracion', 'fechaExpiracion', 'acciones'];
  dataSource = new MatTableDataSource<EntregaEquipoLink>(this.pendientes_List);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private alert: AlertHelper,
    private entregaEquipoLinkService: EntregaEquipoLinkService,
    private dialog: MatDialog
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.pendientes_List != undefined) {
      this.dataSource = new MatTableDataSource<EntregaEquipoLink>(this.pendientes_List || []);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  formatearRut(rut: string): string {
    return rut ? formatRut(rut) : '';
  }

  abrirEditar(link: EntregaEquipoLink) {
    const dialogRef = this.dialog.open(EditarLinkDialogComponent, {
      width: '500px',
      data: { link }
    });
    dialogRef.afterClosed().subscribe((cambios) => {
      if (cambios) {
        this.actualizado.emit(true);
      }
    });
  }

  copiarLink(token: string | undefined) {
    if (!token) {
      return;
    }
    const link = `${window.location.origin}${window.location.pathname}#/firma-entrega/${token}`;
    navigator.clipboard.writeText(link).then(() => {
      this.alert.success_small('Link copiado al portapapeles');
    });
  }

  anular(link: EntregaEquipoLink) {
    Swal.fire({
      title: 'Anular link?',
      text: 'El link de entrega dejará de estar disponible para ser firmado',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff0000',
      cancelButtonColor: '#6c736e',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Anular'
    }).then((result) => {
      if (result.isConfirmed && link.id) {
        this.entregaEquipoLinkService.anular(link.id, { estadoLink: 'ANULADO' }).subscribe(res => {
          if (res.success) {
            this.alert.success_small(res.msg || 'Link anulado correctamente');
            link.estadoLink = 'ANULADO';
            this.dataSource = new MatTableDataSource<EntregaEquipoLink>(this.pendientes_List || []);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          } else {
            this.alert.error_small(res.msg || 'No se pudo anular el link');
          }
        });
      }
    });
  }

}
